module.exports = __webpack_public_path__ + "static/img/循环利用.7db0174c.png";